/**
 * コピー操作共通モジュール
 */

// ディープコピー Dateオブジェクト、undefined、関数は想定通りのコピーがされないので注意
export const deepCopy = <T>(value: T): T => {
  return JSON.parse(JSON.stringify(value));
};
